/* @flow */

import { getBraindateId } from '@braindate/domain/lib/braindate/util';

import {
  notificationBundleTypeFeedback,
  notificationInfoLevel,
  notificationVanillaType,
} from 'src/shared/app/notification/constant/notificationConstants';

import type { Braindate } from '@braindate/domain/lib/braindate/type';
import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import { NOTIFICATION_COMPONENT_KEYS } from 'src/shared/app/notification/constant/notificationComponentsMap';

export function getBraindateFeedbackNotificationId(
  braindate: Braindate,
): string {
  return `braindate-feedback-${getBraindateId(braindate)}`;
}

export function convertPostBraindateFeedbackToNotification(
  braindate: Braindate,
): Notification<> {
  return {
    id: getBraindateFeedbackNotificationId(braindate),
    level: notificationInfoLevel,
    type: notificationVanillaType,
    componentKey: NOTIFICATION_COMPONENT_KEYS.BRAINDATE_FEEDBACK,
    data: braindate,
    bundleType: notificationBundleTypeFeedback,
  };
}
